<script setup lang="ts">
import { ElNotification } from 'element-plus'
// http://localhost:8100/unsubscribe/?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY3Rpb24iOiJ1bnN1YnNjcmliZSIsImlkIjoiMTk0In0.k8kxTQfZF_-DN9K_cm5V-2xPtFCS9apakJoqIY86OUE
import { ModeEnum } from '@/types/enums'

const { t } = useI18n()
const auth = useAuthStore()
const { updateMode, unsubscribeToken } = siteUtils
const loading = ref(false)
onUnmounted(() => {
  unsubscribeToken.value = ''
})
function onSubmit() {
  const { getGoatApiUrl } = siteUtils
  const { getAxiosInstance, catchError } = appUtilsPlugin
  loading.value = true
  getAxiosInstance()
    ?.post(getGoatApiUrl('unsubscribe'), { token: unsubscribeToken.value })
    .then((response) => {
      setTimeout(() => {
        ElNotification.closeAll()
        if (response?.data?.status === 'ok') {
          const { gaChangeCommunication } = gaUtils
          gaChangeCommunication({ gs_context: `acceptCommunication=false`, gs_section: 'email_unsubscribe_link' })
          ElNotification({
            title: t('unsubscribe.notify.success.title'),
            type: 'success',
            duration: 9000,
            appendTo: '#auth-wrapper',
            customClass: 'right-1/2 translate-x-1/2 large absolute'
          })
        } else {
          ElNotification({
            title: t('unsubscribe.notify.unavailable.title'),
            message: t('unsubscribe.notify.unavailable.message'),
            type: 'error',
            duration: 9000,
            appendTo: '#auth-wrapper',
            customClass: 'right-1/2 translate-x-1/2 large absolute'
          })
        }
      }, 1000)
      const { gaChangeCommunication } = gaUtils
      gaChangeCommunication({ gs_context: `acceptCommunication=false`, gs_section: 'email_unsubscribe_link' })
      auth.updateCom(false)
      updateMode(ModeEnum.loggedin)
    })
    .catch(catchError())
    .then(() => {
      loading.value = false
    })
}
</script>

<template>
  <div
    class="box-form-wrapper mx-auto max-w-2xl big:max-w-(--breakpoint-xl) big:px-16 mt-5"
  >
    <div
      class="box-form big:mt-10 mx-3 bg-white pt-10 big:pt-16 pb-10 big:pb-16 px-2 big:px-16 rounded-2xl flex flex-col items-center"
    >
      <div class="mx-auto w-full max-w-md">
        <h1 class="text-lg big:text-2xl uppercase font-semibold text-center tracking-wider mb-3 ">
          {{ t('unsubscribe.title') }}
        </h1>
        <div class="text-center">
          {{ t('unsubscribe.description') }}
        </div>
        <goat-form-component
          class="mt-6 big:mb-5 w-full"
          size="large"
          hide-required-asterisk
          @submit="onSubmit"
        >
          <template #default="{ submit }">
            <goat-form-fields-group
              justify="space-between"
            >
              <el-button
                type="info"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                @click="updateMode(ModeEnum.loggedin)"
              >
                {{ t('unsubscribe.cancelBtn') }}
              </el-button>
              <el-button
                type="primary"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                size="large"
                :loading="loading"
                @click="submit()"
              >
                {{ t('unsubscribe.confirmBtn') }}
              </el-button>
            </goat-form-fields-group>
          </template>
        </goat-form-component>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
</style>
